import winston, { Logger } from "winston";

let loggerInstance: winston.Logger | null = null;

function GetLogger(): Logger {
  if (!loggerInstance) {
    loggerInstance = winston.createLogger({
      level: process.env.LOG_LEVEL || "info",
      format: winston.format.json(),
      transports: [new winston.transports.Console()],
    });
  }
  return loggerInstance;
}

export const info = (message: string, rest: any) => {
  log("info", message, rest);
};

export const warn = (message: string, rest: any) => {
  log("warn", message, rest);
};

export const error = (message: string, rest: any) => {
  log("error", message, rest);
};

export const debug = (message: string, rest: any) => {
  log("debug", message, rest);
};

const log = (
  severity: "info" | "warn" | "error" | "debug",
  message: string,
  rest: any
) => {
  const logger = GetLogger()[severity];
  if (rest.error instanceof Error) {
    rest.error = {
      message: rest.error.message,
      stack: rest.error.stack,
    };
  }
  const metadata = {
    ...rest,
  };
  if (rest.operation) {
    logger(
      `[Database] [${severity.toUpperCase()}] [${rest.operation}] - ${message}`,
      { metadata }
    );
  } else {
    logger(`[Database] [${severity.toUpperCase()}] - ${message}`, {
      metadata,
    });
  }
};

export default GetLogger;
